module.exports = __webpack_public_path__ + "img/3.60b0217a.png";